import React from 'react'
import PropTypes from 'prop-types'
import {Button} from 'reactstrap'

const UpgradeButton = props => {
    const {size = 'lg', color = 'primary', title = 'Upgrade'} = props
    return (
        <Button.Ripple size={size} type='button' color={color} target={'_blank'} tag={'a'}
                       href={'/workspace/settings/plans'}>
            {/*<span>{trans('featureComponent.upgradeToPlan', {plan: feature.require})}</span>*/}
            <span>{title}</span>
        </Button.Ripple>
    )
}

UpgradeButton.propTypes = {

}

export default UpgradeButton
